<script>
export default {
  name: 'UserLayout',
  data() {
    let userEmail = '';

    try {
      const storedUser = localStorage.getItem('user');
      userEmail = storedUser ? (JSON.parse(storedUser)?.email || '') : '';
    } catch {
      userEmail = '';
    }

    return {
      userEmail,
      accountOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    toggleAccountMenu() {
      this.accountOpen = !this.accountOpen;
    },
    closeAccountMenu() {
      this.accountOpen = false;
    },
    handleDocumentClick(event) {
      const accountMenu = this.$refs.accountMenu;

      if (
        this.accountOpen &&
        accountMenu &&
        !accountMenu.contains(event.target)
      ) {
        this.accountOpen = false;
      }
    },
    logout() {
      this.accountOpen = false;
      localStorage.removeItem('token');
      this.$router.push('/login');
    }
  }
};
</script>

<template>
  <div class="flex h-screen flex-col overflow-hidden">
    <!-- Top Navigation Bar -->
    <header
      class="relative z-20 flex h-14 shrink-0 items-center justify-between border-b border-slate-200 bg-slate-50 px-5 text-slate-800"
    >
      <div class="flex min-w-0 items-center gap-5">
        <!-- Library title -->
        <span class="whitespace-nowrap text-[15px] font-semibold tracking-tight text-slate-900">
          SBU Geosciences Spectral Library
        </span>

        <!-- Visual separator -->
        <span class="h-5 border-l border-slate-300"></span>

        <!-- Primary navigation -->
        <nav aria-label="Primary navigation">
          <ul class="flex items-center gap-1">
            <li>
              <router-link
                to="/user/main-layout"
                class="rounded-md px-3 py-1.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
                exact-active-class="bg-blue-50 text-blue-700"
              >
                Library Home
              </router-link>
            </li>

            <li>
              <router-link
                to="/user/folder-management"
                class="rounded-md px-3 py-1.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
                exact-active-class="bg-blue-50 text-blue-700"
              >
                Folder Management
              </router-link>
            </li>

            <li>
              <router-link
                to="/user/upload-file"
                class="rounded-md bg-blue-600 px-3.5 py-1.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700"
                exact-active-class="ring-2 ring-blue-200 ring-offset-1"
              >
                Upload File
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <!-- Account menu -->
      <div ref="accountMenu" class="relative ml-4 shrink-0">
        <button
          type="button"
          class="flex max-w-72 items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-200"
          :aria-expanded="accountOpen"
          aria-haspopup="menu"
          @click.stop="toggleAccountMenu"
        >
          <span class="max-w-56 truncate">{{ userEmail }}</span>
          <span
            class="text-xs text-slate-500 transition-transform"
            :class="accountOpen ? 'rotate-180' : ''"
            aria-hidden="true"
          >
            ▾
          </span>
        </button>

        <div
          v-if="accountOpen"
          class="absolute right-0 top-full mt-2 w-52 overflow-hidden rounded-lg border border-slate-200 bg-white py-1 shadow-lg"
          role="menu"
        >
          <router-link
            to="/user/change-password"
            class="block px-4 py-2.5 text-sm text-slate-700 transition-colors hover:bg-blue-50 hover:text-blue-700"
            role="menuitem"
            @click="closeAccountMenu"
          >
            Change Password
          </router-link>

          <div class="my-1 border-t border-slate-100"></div>

          <button
            type="button"
            class="block w-full px-4 py-2.5 text-left text-sm text-slate-700 transition-colors hover:bg-slate-50 hover:text-slate-950"
            role="menuitem"
            @click="logout"
          >
            Logout
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content Area -->
    <main class="min-h-0 flex-1 overflow-auto bg-white p-8">
      <router-view></router-view>
    </main>
  </div>
</template>

<style scoped>
</style>
